// import Heap from 'reactjs-heap'

export const Heap = {
  identify: (userId: string) => {
    return userId
  }
}
